import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SummaryCell, SummaryCellType, ViewToggleOption } from "../card-types";

@Component({
  selector: "summary-section-card",
  templateUrl: "./summary-section-card.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class SummarySectionCardComponent {
  @Input() icon: string;
  @Input() title: string;
  @Input() description: string;
  @Input() hint: string;
  @Input() cells: SummaryCell[] = [];
  @Input() loading: boolean = false;
  @Input() comingSoon: boolean = false;
  @Input() showExport: boolean = true;
  @Input() showDashboardLink: boolean = false;
  @Input() isReport: boolean = false;
  @Input() exportOptions: ViewToggleOption[] = [];
  @Input() dashboardOptions: ViewToggleOption[] = [];
  summaryCellType = SummaryCellType;
  exportMenuOpen: boolean = false;
  dashboardMenuOpen: boolean = false;
  @Output() exportClick = new EventEmitter<void>();
  @Output() exportOptionSelect = new EventEmitter<string>();
  @Output() dashboardClick = new EventEmitter<void>();
  @Output() dashboardOptionSelect = new EventEmitter<string>();

  trackByIndex(index: number): number {
    return index;
  }

  onExportClick() {
    if (this.exportOptions.length > 0) {
      this.dashboardMenuOpen = false;
      this.exportMenuOpen = !this.exportMenuOpen;
    } else {
      this.exportClick.emit();
    }
  }

  selectExportOption(value: string) {
    this.exportMenuOpen = false;
    this.exportOptionSelect.emit(value);
  }

  closeExportMenu() {
    this.exportMenuOpen = false;
  }

  onDashboardClick() {
    if (this.dashboardOptions.length > 0) {
      this.exportMenuOpen = false;
      this.dashboardMenuOpen = !this.dashboardMenuOpen;
    } else {
      this.dashboardClick.emit();
    }
  }

  selectDashboardOption(value: string) {
    this.dashboardMenuOpen = false;
    this.dashboardOptionSelect.emit(value);
  }

  closeDashboardMenu() {
    this.dashboardMenuOpen = false;
  }
}
